import { Helmet } from "react-helmet-async";
import Carousel from "../../components/carousel";
import AboutComponent from "../../components/about";
import { WhyChooseUs } from "../../components/chooseUs";
import ContactUs from "../../components/contact";

export default function Home() {
  return (
    <div className="">
      <Helmet>
        <title>Clima Tropical - Climatização e Serviços em Angola</title>

        <meta
          name="description"
          content="Clima Tropical oferece soluções completas em climatização, ar condicionado, serviços elétricos e construção civil em Angola. Qualidade, eficiência e confiança."
        />

        <meta
          name="keywords"
          content="Clima Tropical, climatização Angola, ar condicionado Luanda, serviços elétricos, construção civil, manutenção de ar condicionado, soluções técnicas Angola"
        />

        <link rel="canonical" href="https://climatropical.com/" />

        {/* Open Graph */}
        <meta property="og:title" content="Clima Tropical - Serviços em Angola" />
        <meta
          property="og:description"
          content="Soluções profissionais em climatização, construção civil e serviços técnicos em Angola."
        />
        <meta property="og:url" content="https://climatropical.com/" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:title" content="Clima Tropical - Angola" />
        <meta
          name="twitter:description"
          content="Especialistas em climatização, construção civil e serviços técnicos em Angola."
        />
      </Helmet>

      <Carousel />
      <AboutComponent />
      <WhyChooseUs />
      <ContactUs />
    </div>
  );
}